globalThis["__sentryRewritesTunnelPath__"] = "/monitoring-tunnel";
globalThis["SENTRY_RELEASE"] = {"id":"4e7102ae"};
globalThis["__sentryBasePath"] = undefined;
globalThis["__rewriteFramesAssetPrefixPath__"] = "/client-portal/4e7102ae0f799d3a65e1b5967d38b8735f3da781";
// Client-side Sentry configuration (browser)
// https://docs.sentry.io/platforms/javascript/guides/nextjs/
import * as Sentry from '@sentry/nextjs';

// Define allowed environments
type Environment = 'local' | 'develop' | 'staging' | 'preprod' | 'production';

// Get current environment
const getCurrentEnvironment = (): Environment => {
  const env = process.env.NEXT_PUBLIC_ENV_NAME;
  switch (env) {
    case 'staging':
      return 'staging';
    case 'preprod':
      return 'preprod';
    case 'production':
      return 'production';
    case 'develop':
      return 'develop';
    default:
      return 'local';
  }
};

// Get environment specific configuration
const getEnvConfig = (environment: Environment) => {
  const configs = {
    develop: {
      tracesSampleRate: 1.0,
      debug: true
    },
    staging: {
      tracesSampleRate: 0.5,
      debug: true
    },
    preprod: {
      tracesSampleRate: 0.2,
      debug: false
    },
    production: {
      tracesSampleRate: 1.0, // between 0 - 1
      debug: false
    },
    local: {
      tracesSampleRate: 1.0,
      debug: false
    }
  };

  return configs[environment];
};

const environment = getCurrentEnvironment();
const envConfig = getEnvConfig(environment);

Sentry.init({
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
  environment,
  integrations: [
    //TODO @ashutosh need to enable it
    // Critical integration for filtering third-party errors - !!!! DO NOT MODIFY !!!!
    // Sentry.thirdPartyErrorFilterIntegration({
    // filterKeys: ['V1-APPLICANT-PORTAL'],
    // behaviour: 'drop-error-if-contains-third-party-frames'
    // }),
  ],

  beforeSend(event) {
    if (process.env.NODE_ENV === 'development') {
      // eslint-disable-next-line no-console
      console.log('TEST_SENTRY', event);
    }

    // Add environment data to the event
    event.environment = environment;
    event.tags = {
      ...event.tags,
      environment
    };

    return event;
  },

  // Use environment specific configuration
  tracesSampleRate: envConfig.tracesSampleRate,
  debug: envConfig.debug,

  enabled: !!(
    process.env.NODE_ENV !== 'development' &&
    process.env.NEXT_PUBLIC_SENTRY_ENABLED
  )
  // Enable this for local testing
  // enabled: true
});
